import Request from 'request';

const APP_STARTUP_API_URL = '/appstartup/api';
const APP_ASSETS_API_URL = '/appassets/api';

function isAbsolutePath(path) {
    return typeof path === 'string' && path.indexOf('/') === 0;
}

export default {
    get(path, data) {
        if (isAbsolutePath(path)) {
            return Request.get(path, data);
        }

        return Request.get(APP_STARTUP_API_URL, {
            ...(data || {}),
            path
        });
    },

    post(path, data) {
        if (isAbsolutePath(path)) {
            return Request.post(path, data);
        }

        return Request.post(APP_STARTUP_API_URL, {
            ...(data || {}),
            path
        });
    },

    postJSON(path, data, timeout) {
        if (isAbsolutePath(path)) {
            return Request.postJSON(path, data, timeout);
        }

        return Request.postJSON(
            APP_STARTUP_API_URL,
            {
                ...(data || {}),
                path
            },
            timeout
        );
    }
};
